export const settings = [
  {
    path: '/settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/Settings'),
    children: [
      {
        path: 'event',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/components/SettingsEvent'),
      },
      {
        path: 'sessions',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/components/SettingsSessions'),
      },
      {
        path: 'sessions/:group/:id',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/components/SettingsSessionsEdit'),
      },
      {
        path: 'persons',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/components/SettingsPersons'),
      },
      {
        path: 'countries',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/components/SettingsCountries'),
      },
      {
        path: 'display',
        component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/components/SettingsDisplay'),
      },
    ],
    redirect: '/settings/event',
  },
]
